{
  "title": "عقود الصيانة",
  "retry": "حاول مرة أخرى",
  "conflictLoaded": "تغيّر هذا العقد في الأثناء. حُمّلت أحدث نسخة منه: راجعها وحاول مجددًا.",
  "status": {
    "DRAFT": "مسودة",
    "ACTIVE": "ساري",
    "EXPIRED": "منتهٍ",
    "TERMINATED": "مفسوخ",
    "CANCELLED": "ملغى"
  },
  "actions": {
    "new": "عقد جديد",
    "activate": "تفعيل",
    "renew": "تجديد",
    "edit": "تعديل",
    "print": "طباعة العقد",
    "terminate": "إنهاء العقد",
    "cancelDraft": "إلغاء المسودة",
    "generate": "إنشاء الزيارات الوقائية الآن"
  },
  "punch": {
    "state": {
      "DONE": "تمت",
      "PARTIAL": "تمت جزئياً",
      "PLANNED": "مخططة",
      "LATE": "متأخرة",
      "MISSED": "فائتة",
      "SKIPPED": "تم تخطيها",
      "NONE": "لا شيء مستحق"
    },
    "underway": "جارية",
    "quarter": "Q{{n}}",
    "half": "H{{n}}",
    "week": "W{{n}}",
    "quarterLong": {
      "1": "الربع الأول {{year}}",
      "2": "الربع الثاني {{year}}",
      "3": "الربع الثالث {{year}}",
      "4": "الربع الرابع {{year}}"
    },
    "halfLong": {
      "1": "النصف الأول {{year}}",
      "2": "النصف الثاني {{year}}"
    },
    "weekLong": "الأسبوع {{n}} من {{year}}",
    "current": "الفترة الحالية",
    "visitsDone_zero": "تمت {{done}} من {{due}} زيارة",
    "visitsDone_one": "تمت {{done}} من {{due}} زيارة",
    "visitsDone_two": "تمت {{done}} من {{due}} زيارة",
    "visitsDone_few": "تمت {{done}} من {{due}} زيارات",
    "visitsDone_many": "تمت {{done}} من {{due}} زيارة",
    "visitsDone_other": "تمت {{done}} من {{due}} زيارة",
    "empty": "لا فترات بعد."
  },
  "interval": {
    "WEEK_zero": "كل أسبوع",
    "WEEK_one": "كل أسبوع",
    "WEEK_two": "كل أسبوعين",
    "WEEK_few": "كل {{n}} أسابيع",
    "WEEK_many": "كل {{n}} أسبوعاً",
    "WEEK_other": "كل {{n}} أسبوع",
    "MONTH_zero": "كل شهر",
    "MONTH_one": "كل شهر",
    "MONTH_two": "كل شهرين",
    "MONTH_few": "كل {{n}} أشهر",
    "MONTH_many": "كل {{n}} شهراً",
    "MONTH_other": "كل {{n}} شهر",
    "YEAR_zero": "كل سنة",
    "YEAR_one": "كل سنة",
    "YEAR_two": "كل سنتين",
    "YEAR_few": "كل {{n}} سنوات",
    "YEAR_many": "كل {{n}} سنة",
    "YEAR_other": "كل {{n}} سنة"
  },
  "period": {
    "starts": "يبدأ في {{date}}",
    "startsIn_zero": "يبدأ اليوم",
    "startsIn_one": "يبدأ خلال يوم واحد",
    "startsIn_two": "يبدأ خلال يومين",
    "startsIn_few": "يبدأ خلال {{n}} أيام",
    "startsIn_many": "يبدأ خلال {{n}} يوماً",
    "startsIn_other": "يبدأ خلال {{n}} يوم",
    "endsIn_zero": "ينتهي اليوم",
    "endsIn_one": "ينتهي خلال يوم واحد",
    "endsIn_two": "ينتهي خلال يومين",
    "endsIn_few": "ينتهي خلال {{n}} أيام",
    "endsIn_many": "ينتهي خلال {{n}} يوماً",
    "endsIn_other": "ينتهي خلال {{n}} يوم",
    "endsToday": "ينتهي اليوم",
    "endedAgo_zero": "انتهى اليوم",
    "endedAgo_one": "انتهى منذ يوم واحد",
    "endedAgo_two": "انتهى منذ يومين",
    "endedAgo_few": "انتهى منذ {{n}} أيام",
    "endedAgo_many": "انتهى منذ {{n}} يوماً",
    "endedAgo_other": "انتهى منذ {{n}} يوم",
    "day": "اليوم {{day}} من {{total}}"
  },
  "renewal": {
    "renewedBy": "جُدّد بالعقد",
    "renews": "تجديد للعقد"
  },
  "compliance": {
    "none": "لا زيارات وقائية مستحقة بعد",
    "figure": "تمت {{done}} من {{due}} زيارة وقائية · {{percent}}%",
    "figureSkipped_zero": "تمت {{done}} من {{due}} زيارة وقائية · {{percent}}%",
    "figureSkipped_one": "تمت {{done}} من {{due}} زيارة وقائية · {{percent}}% (تُخطيت زيارة واحدة)",
    "figureSkipped_two": "تمت {{done}} من {{due}} زيارة وقائية · {{percent}}% (تُخطيت زيارتان)",
    "figureSkipped_few": "تمت {{done}} من {{due}} زيارة وقائية · {{percent}}% (تُخطيت {{n}} زيارات)",
    "figureSkipped_many": "تمت {{done}} من {{due}} زيارة وقائية · {{percent}}% (تُخطيت {{n}} زيارة)",
    "figureSkipped_other": "تمت {{done}} من {{due}} زيارة وقائية · {{percent}}% (تُخطيت {{n}} زيارة)"
  },
  "schedule": {
    "MONTHLY": "شهري",
    "QUARTERLY": "ربع سنوي",
    "HALF_YEARLY": "نصف سنوي",
    "YEARLY": "سنوي",
    "UPFRONT": "مقدماً (قسط واحد)",
    "CUSTOM": "مخصص (يُدخل يدوياً)"
  },
  "scheduleWord": {
    "MONTHLY": "شهري",
    "QUARTERLY": "ربع سنوي",
    "HALF_YEARLY": "نصف سنوي",
    "YEARLY": "سنوي",
    "UPFRONT": "مقدمًا",
    "CUSTOM": "مخصص"
  },
  "timing": {
    "ADVANCE": "في بداية الفترة",
    "ARREARS": "في نهاية الفترة"
  },
  "timingBody": {
    "ADVANCE": "يُفوتر كل قسط في أول يوم من فترته.",
    "ARREARS": "يُفوتر كل قسط في آخر يوم من فترته."
  },
  "timingShort": {
    "ADVANCE": "في بداية الفترة",
    "ARREARS": "في نهاية الفترة"
  },
  "terms": {
    "title": "الشروط",
    "labour": "العمالة",
    "parts": "قطع الغيار",
    "consumables": "المواد الاستهلاكية",
    "callOuts": "بلاغات الأعطال",
    "response": "زمن الاستجابة",
    "noResponse": "بلا زمن محدد",
    "special": "شروط خاصة",
    "notes": "ملاحظات",
    "billingTitle": "السعر والفوترة",
    "value": "القيمة (قبل الضريبة)",
    "taxRate": "ضريبة القيمة المضافة",
    "defaultTax": "نسبة المبيعات الافتراضية للشركة",
    "schedule": "الفوترة",
    "timing": "موعد الفوترة",
    "callOutsUsed": "استُخدم {{used}} من {{allowance}} بلاغات أعطال في سنة العقد هذه",
    "callOutsUsedUnlimited_zero": "لا بلاغات أعطال في سنة العقد هذه",
    "callOutsUsedUnlimited_one": "بلاغ عطل واحد في سنة العقد هذه",
    "callOutsUsedUnlimited_two": "بلاغا عطل في سنة العقد هذه",
    "callOutsUsedUnlimited_few": "{{n}} بلاغات أعطال في سنة العقد هذه",
    "callOutsUsedUnlimited_many": "{{n}} بلاغاً في سنة العقد هذه",
    "callOutsUsedUnlimited_other": "{{n}} بلاغ عطل في سنة العقد هذه",
    "words": {
      "labour": {
        "INCLUDED": "العمالة مشمولة",
        "EXCLUDED": "العمالة بمقابل"
      },
      "parts": {
        "INCLUDED": "قطع الغيار مشمولة",
        "EXCLUDED": "قطع الغيار بمقابل",
        "CAPPED": "قطع الغيار مشمولة حتى سقف"
      },
      "partsCap": {
        "PER_JOB": "قطع الغيار مشمولة حتى {{cap}} لكل أمر",
        "PER_YEAR": "قطع الغيار مشمولة حتى {{cap}} في كل سنة عقد"
      },
      "partsCapped": "قطع الغيار مشمولة حتى سقف",
      "consumables": {
        "INCLUDED": "المواد الاستهلاكية مشمولة",
        "EXCLUDED": "المواد الاستهلاكية بمقابل"
      },
      "callOutsAllowance_zero": "لا بلاغات أعطال مشمولة سنوياً",
      "callOutsAllowance_one": "بلاغ عطل واحد مشمول سنوياً",
      "callOutsAllowance_two": "بلاغا عطل مشمولان سنوياً",
      "callOutsAllowance_few": "{{n}} بلاغات أعطال مشمولة سنوياً",
      "callOutsAllowance_many": "{{n}} بلاغاً مشمولاً سنوياً",
      "callOutsAllowance_other": "{{n}} بلاغ عطل مشمول سنوياً",
      "callOutsUnlimited": "بلاغات الأعطال مشمولة",
      "callOutsExcluded": "بلاغات الأعطال بمقابل",
      "response_zero": "الاستجابة فوراً",
      "response_one": "الاستجابة خلال ساعة واحدة",
      "response_two": "الاستجابة خلال ساعتين",
      "response_few": "الاستجابة خلال {{n}} ساعات",
      "response_many": "الاستجابة خلال {{n}} ساعة",
      "response_other": "الاستجابة خلال {{n}} ساعة"
    }
  },
  "reason": {
    "LABOUR_INCLUDED": "العمالة مشمولة",
    "LABOUR_EXCLUDED": "العمالة بمقابل في هذا العقد",
    "CALL_OUTS_EXCLUDED": "بلاغات الأعطال بمقابل في هذا العقد",
    "CALL_OUT_OVER_ALLOWANCE": "تجاوز عدد بلاغات الأعطال المشمولة للسنة",
    "PARTS_INCLUDED": "قطع الغيار مشمولة",
    "PARTS_EXCLUDED": "قطع الغيار بمقابل في هذا العقد",
    "PARTS_WITHIN_CAP": "ضمن سقف قطع الغيار",
    "PARTS_OVER_CAP": "تجاوز سقف قطع الغيار",
    "CONSUMABLES_INCLUDED": "المواد الاستهلاكية مشمولة",
    "CONSUMABLES_EXCLUDED": "المواد الاستهلاكية بمقابل في هذا العقد",
    "SET_BY_HAND": "حُدّد يدوياً"
  },
  "checkOutcome": {
    "DONE": "تم",
    "ISSUE": "وُجد عطل",
    "NO_ACCESS": "تعذّر الوصول",
    "SKIPPED": "تم التخطي"
  },
  "checkResult": {
    "done": "تم",
    "notDone": "لم يتم"
  },
  "errors": {
    "CONTRACTS_OFF": "عقود الصيانة متوقفة لشركتك.",
    "CONTRACT_NOT_ACTIVE": "هذا العقد غير ساري اليوم فلا يقبل الأمر. اختر عقداً آخر أو اجعل الأمر بمقابل.",
    "CONTRACT_NOT_FOR_SITE": "هذا العقد لا يشمل موقع الأمر.",
    "CONTRACT_NOT_DRAFT": "لا تُفعَّل ولا تُلغى إلا المسودة.",
    "CONTRACT_NOT_ACTIVE_STATE": "لا يُنهى إلا العقد الساري.",
    "CONTRACT_FINAL": "انتهى هذا العقد ولم يعد يتغير.",
    "CONTRACT_INCOMPLETE": "يحتاج العقد قبل تفعيله إلى موقع واحد على الأقل وتغطية تشمل معدة.",
    "CONTRACT_PENDING_APPROVAL": "العقد بانتظار الاعتماد ولا يتغير حتى يُبت فيه.",
    "ALREADY_RENEWED": "جُدّد هذا العقد من قبل.",
    "NOT_RENEWABLE": "لا يُجدَّد عقد مفسوخ أو ملغى.",
    "RENEWAL_OVERLAP": "يبدأ التجديد بعد آخر يوم في العقد الذي يجدّده: لا يغطي العقدان اليوم نفسه.",
    "SITE_UNDER_CONTRACT": "يغطي هذا الموقعَ عقدُ صيانة ساري: افسخه أو أخرج الموقع منه أولًا.",
    "SITE_NOT_OF_CUSTOMER": "أحد المواقع المختارة ليس لهذا العميل أو مؤرشف.",
    "ASSET_NOT_AT_SITE": "إحدى المعدات المختارة ليست في مواقع العقد.",
    "SITE_HAS_OPEN_JOBS": "لا يخرج موقع من العقد وله أوامر وقائية مفتوحة.",
    "OCCURRENCE_STARTED": "بدأت هذه الزيارة الوقائية فلا يمكن تخطيها.",
    "OCCURRENCE_SKIPPED": "تم تخطي هذه الزيارة الوقائية من قبل.",
    "BILLING_ITEM_INVOICED": "فُوتر هذا القسط ولم يعد يتغير.",
    "BILLING_ITEM_NOT_READY": "هذا القسط ليس جاهزاً للفوترة بعد.",
    "BILLING_ITEM_CANCELLED": "هذا القسط ملغى.",
    "SALES_MODULE_OFF": "المبيعات متوقفة لشركتك فلا تُفوتر الأقساط.",
    "ASSET_CHECKS_OFF": "قوائم فحص المعدات متوقفة في الإعدادات › الخدمة.",
    "ASSET_NOT_ON_JOB": "هذه المعدة ليست على الأمر.",
    "ASSET_NOT_IN_VISIT_SCOPE": "هذه المعدة ليست في الأماكن التي تشملها الزيارة.",
    "CHECKS_INCOMPLETE": "لم تُفحص بعد كل معدات هذا الأمر الوقائي.",
    "PLACE_NOT_AT_SITE": "أحد الأماكن المختارة ليس في موقع الأمر."
  },
  "register": {
    "title": "عقود الصيانة",
    "count_zero": "لا عقود",
    "count_one": "عقد واحد",
    "count_two": "عقدان",
    "count_few": "{{n}} عقود",
    "count_many": "{{n}} عقداً",
    "count_other": "{{n}} عقد",
    "views": "عروض العقود",
    "view": {
      "active": "السارية",
      "expiring": "قاربت الانتهاء",
      "draft": "المسودات",
      "ended": "المنتهية",
      "all": "الكل"
    },
    "searchPlaceholder": "ابحث بالرقم أو العنوان أو العميل…",
    "searchLabel": "البحث في العقود",
    "clearSearch": "مسح البحث",
    "clearFilters": "مسح عوامل التصفية",
    "filterCustomer": "العميل",
    "anyCustomer": "أي عميل",
    "forCustomer": "عقود {{name}}",
    "tableLabel": "عقود الصيانة",
    "untitled": "بلا عنوان",
    "moreSites_zero": "ولا مواقع أخرى",
    "moreSites_one": "وموقع آخر",
    "moreSites_two": "وموقعان آخران",
    "moreSites_few": "و{{n}} مواقع أخرى",
    "moreSites_many": "و{{n}} موقعاً آخر",
    "moreSites_other": "و{{n}} موقع آخر",
    "recentLabel": "{{number}}: آخر فترات خططه",
    "recentPlanLabel": "{{number}}: {{plan}}، آخر الفترات",
    "pendingApproval": "بانتظار الاعتماد",
    "nextDue": "الزيارة التالية {{date}}",
    "overdueSince": "متأخرة منذ {{date}}",
    "empty": {
      "title": "لا عقود بعد.",
      "body": "أضف العقد الأول: مواقع العميل وما يشمله العقد وبأي شروط.",
      "readOnly": "تظهر العقود هنا عندما يضيفها أحد.",
      "filteredTitle": "لا عقود مطابقة.",
      "filteredBody": "جرّب كلمات أخرى أو امسح عوامل التصفية.",
      "view": {
        "active": "لا عقود سارية.",
        "expiring": "لا عقد ينتهي خلال الستين يوماً القادمة.",
        "draft": "لا مسودات.",
        "ended": "لم ينتهِ أي عقد.",
        "all": "لا عقود."
      }
    }
  },
  "columns": {
    "number": "الرقم",
    "customer": "العميل",
    "title": "العنوان",
    "sites": "المواقع",
    "period": "المدة",
    "value": "القيمة",
    "compliance": "الالتزام",
    "nextDue": "الزيارة الوقائية التالية",
    "status": "الحالة"
  },
  "page": {
    "title": "عقد صيانة",
    "backToRegister": "العودة إلى العقود",
    "pendingApproval": "بانتظار الاعتماد",
    "pendingApprovalReason": "العقد بانتظار الاعتماد.",
    "pendingApprovalTitle": "بانتظار الاعتماد",
    "pendingApprovalBody": "أُرسل العقد للاعتماد، ولا يتغير حتى يُعتمد أو يُعاد.",
    "terminatedTitle": "أُنهي اعتباراً من {{date}} بواسطة {{name}}",
    "cancelledTitle": "أُلغي في {{date}}",
    "expiredTitle": "انتهى في {{date}}",
    "expiredRenew": "لم يعد يشمل الأوامر. جدّده ليبقى العميل مشمولاً.",
    "expiredBody": "لم يعد يشمل الأوامر.",
    "draftNoSites": "اختر مواقع العميل قبل التفعيل: عدّل المسودة.",
    "soldBy": "باعه {{name}}"
  },
  "figures": {
    "label": "أرقام العقد",
    "value": "القيمة",
    "valueSub": "قبل الضريبة",
    "starts": "يبدأ في",
    "startsSub": "مسودة حتى تفعيلها",
    "invoiced": "المُفوتر",
    "invoicedSub": "شامل الضريبة",
    "collected": "المُحصّل",
    "balance": "الرصيد",
    "visits": "الزيارات الوقائية",
    "ofCount": "{{done}} من {{due}}",
    "compliance": "التزام {{percent}}%",
    "complianceSkipped_zero": "التزام {{percent}}%",
    "complianceSkipped_one": "التزام {{percent}}% (تُخطيت زيارة واحدة)",
    "complianceSkipped_two": "التزام {{percent}}% (تُخطيت زيارتان)",
    "complianceSkipped_few": "التزام {{percent}}% (تُخطيت {{n}} زيارات)",
    "complianceSkipped_many": "التزام {{percent}}% (تُخطيت {{n}} زيارة)",
    "complianceSkipped_other": "التزام {{percent}}% (تُخطيت {{n}} زيارة)",
    "issues": "أعطال مفتوحة",
    "issuesSub": "معدات بها عطل لم يُصلح بعد",
    "callOuts": "بلاغات الأعطال",
    "callOutsSub": "في سنة العقد هذه، منذ {{date}}",
    "callOutsUnlimited": "في سنة العقد هذه"
  },
  "tabs": {
    "label": "أقسام العقد",
    "coverage": "التغطية",
    "plans": "خطط الصيانة",
    "visits": "الزيارات",
    "terms": "الشروط",
    "jobs": "الأوامر",
    "files": "الملفات",
    "activity": "السجل",
    "billing": "الفوترة",
    "tasks": "المهام"
  },
  "coverage": {
    "words": {
      "ALL": "كل ما في هذه المواقع",
      "TYPES": "{{types}} في هذه المواقع",
      "ASSETS_zero": "قائمة مختارة بلا معدات",
      "ASSETS_one": "قائمة مختارة من معدة واحدة",
      "ASSETS_two": "قائمة مختارة من معدتين",
      "ASSETS_few": "قائمة مختارة من {{n}} معدات",
      "ASSETS_many": "قائمة مختارة من {{n}} معدة",
      "ASSETS_other": "قائمة مختارة من {{n}} معدة"
    },
    "coveredNow_zero": "لا معدات مشمولة الآن",
    "coveredNow_one": "معدة واحدة مشمولة الآن",
    "coveredNow_two": "معدتان مشمولتان الآن",
    "coveredNow_few": "{{n}} معدات مشمولة الآن",
    "coveredNow_many": "{{n}} معدة مشمولة الآن",
    "coveredNow_other": "{{n}} معدة مشمولة الآن",
    "coveredEnded_zero": "لم يشمل أي معدة",
    "coveredEnded_one": "شمل معدة واحدة",
    "coveredEnded_two": "شمل معدتين",
    "coveredEnded_few": "شمل {{n}} معدات",
    "coveredEnded_many": "شمل {{n}} معدة",
    "coveredEnded_other": "شمل {{n}} معدة",
    "sites": "المواقع",
    "site": "الموقع",
    "covered": "المشمول",
    "ofAssets": "{{covered}} من {{total}}",
    "ofAssetsCount_zero": "{{covered}} من لا معدات",
    "ofAssetsCount_one": "{{covered}} من معدة واحدة",
    "ofAssetsCount_two": "{{covered}} من معدتين",
    "ofAssetsCount_few": "{{covered}} من {{n}} معدات",
    "ofAssetsCount_many": "{{covered}} من {{n}} معدة",
    "ofAssetsCount_other": "{{covered}} من {{n}} معدة",
    "archived": "مؤرشف",
    "noSites": "لا مواقع بعد.",
    "noSitesBody": "عدّل المسودة لاختيار مواقع العميل.",
    "assetsTitle": "المعدات المشمولة",
    "filterSite": "الموقع",
    "allSites": "كل المواقع",
    "search": "ابحث بالرمز أو المكان أو النوع…",
    "clearSearch": "مسح البحث",
    "noAssets": "لا معدات مشمولة بعد.",
    "noAssetsBody": "تُشمل المعدات المضافة إلى مواقع العقد فور إضافتها.",
    "noMatches": "لا معدة مشمولة مطابقة.",
    "neverChecked": "لم تُفحص بعد",
    "columns": {
      "asset": "المعدة",
      "type": "النوع",
      "place": "المكان",
      "site": "الموقع",
      "warranty": "الضمان حتى",
      "lastCheck": "آخر فحص"
    }
  },
  "plans": {
    "title": "خطط الصيانة",
    "tagTitle": "بطاقة الصيانة",
    "stripLabel": "{{name}}: بطاقة الصيانة",
    "noneShort": "لا خطط صيانة بعد: تبدأ الزيارات الوقائية بعد إضافة خطة.",
    "emptyTitle": "لا خطط صيانة بعد.",
    "emptyBody": "أضف خطة صيانة: ما يُصان وكل كم وبأي قائمة فحص.",
    "emptyReadOnly": "تُنشئ خطط الصيانة الزيارات الوقائية؛ لم تُعدّ أي خطة بعد.",
    "addTitle": "إضافة خطة صيانة",
    "add": "إضافة الخطة",
    "save": "حفظ الخطة",
    "edit": "تعديل",
    "editTitle": "تعديل {{name}}",
    "drawerBody": "تحتفظ الأوامر الوقائية المُنشأة بمواعيدها؛ وتتبع الأوامر التالية هذه الخطة.",
    "pause": "إيقاف مؤقت",
    "resume": "استئناف",
    "paused": "متوقفة مؤقتاً",
    "from": "بدءاً من {{date}}",
    "assetCount_zero": "لا معدات",
    "assetCount_one": "معدة واحدة",
    "assetCount_two": "معدتان",
    "assetCount_few": "{{n}} معدات",
    "assetCount_many": "{{n}} معدة",
    "assetCount_other": "{{n}} معدة",
    "checklistItems_zero": "لا بنود: {{items}}",
    "checklistItems_one": "بند واحد: {{items}}",
    "checklistItems_two": "بندان: {{items}}",
    "checklistItems_few": "{{n}} بنود: {{items}}",
    "checklistItems_many": "{{n}} بنداً: {{items}}",
    "checklistItems_other": "{{n}} بند: {{items}}",
    "minutes": "{{n}} دقيقة لكل معدة",
    "nextDue": "الموعد التالي",
    "noMoreDue": "لا زيارات أخرى في هذا العقد",
    "overdueSince": "متأخرة منذ {{date}}",
    "lastErrorTitle": "تعذّر على المُخطِّط إنشاء أوامر هذه الخطة",
    "preview": "أول المواعيد:",
    "previewNone": "لا موعد ضمن مدة العقد",
    "scope": {
      "ALL": "كل معدة مشمولة",
      "ALLBody": "تُصان كل معدة يشملها العقد.",
      "TYPES": "أنواع معدات",
      "TYPESBody": "المعدات المشمولة من الأنواع المختارة فقط."
    },
    "checklist": {
      "TYPE": "قائمة فحص كل نوع معدة",
      "TYPEBody": "كما أُعدّت في الإعدادات › أنواع المعدات.",
      "CUSTOM": "قائمة فحص لهذه الخطة",
      "CUSTOMBody": "قائمة واحدة لكل معدة تشملها الخطة."
    },
    "unit": {
      "WEEK": "أسابيع",
      "MONTH": "أشهر",
      "YEAR": "سنوات"
    },
    "fields": {
      "name": "الاسم",
      "namePlaceholder": "صيانة ربع سنوية شاملة",
      "nameAr": "الاسم بالعربية",
      "scope": "ما تشمله",
      "types": "أنواع المعدات",
      "typesPlaceholder": "اختر أنواع المعدات",
      "typesSearch": "ابحث في أنواع المعدات…",
      "typesEmpty": "لا نوع مطابق.",
      "typesClear": "مسح",
      "typesCount_zero": "لا أنواع",
      "typesCount_one": "نوع واحد",
      "typesCount_two": "نوعان",
      "typesCount_few": "{{n}} أنواع",
      "typesCount_many": "{{n}} نوعاً",
      "typesCount_other": "{{n}} نوع",
      "every": "كل",
      "unit": "الوحدة",
      "firstDue": "أول موعد",
      "firstDueHint": "ضمن مدة العقد",
      "checklist": "قائمة الفحص",
      "minutes": "الدقائق لكل معدة",
      "minutesHint": "لتخطيط الزيارات؛ اختياري"
    },
    "check": {
      "row": "بند الفحص {{n}}",
      "en": "البند",
      "ar": "البند بالعربية",
      "key": "المفتاح",
      "kind": "النوع",
      "kinds": {
        "check": "فحص (تم أو لم يتم)",
        "reading": "قراءة (رقم)"
      },
      "unit": "الوحدة",
      "up": "نقل {{name}} لأعلى",
      "down": "نقل {{name}} لأسفل",
      "remove": "حذف {{name}}",
      "add": "إضافة بند"
    },
    "errors": {
      "name": "سمِّ الخطة.",
      "types": "اختر أنواع المعدات التي تشملها الخطة.",
      "interval": "أدخل رقماً من 1 إلى 60.",
      "firstDue": "اختر أول موعد ضمن مدة العقد.",
      "checklist": "أضف بنود قائمة الفحص، لكل بند مفتاحه.",
      "minutes": "أدخل دقائق من 1 إلى 600 أو اتركها فارغة.",
      "key": "حروف إنجليزية صغيرة وأرقام و _ فقط، يبدأ بحرف.",
      "label": "سمِّ البند بالإنجليزية والعربية.",
      "row": "راجع هذا البند."
    },
    "toast": {
      "added": "أُضيفت الخطة {{name}}",
      "saved": "حُفظت الخطة {{name}}",
      "paused": "أوقفت الخطة {{name}} مؤقتاً",
      "resumed": "استُؤنفت الخطة {{name}}"
    }
  },
  "jobs": {
    "title": "الأوامر ضمن هذا العقد",
    "origin": "نوع الأمر",
    "anyOrigin": "بلاغات الأعطال والزيارات الوقائية",
    "origins": {
      "REQUEST": "بلاغات الأعطال",
      "PLANNED": "الزيارات الوقائية"
    },
    "new": "أمر جديد",
    "empty": "لا أوامر ضمن هذا العقد بعد.",
    "emptyBody": "تُعرض هنا بلاغات الأعطال في مواقعه وزياراته الوقائية.",
    "noneOfOrigin": "لا أوامر من هذا النوع."
  },
  "visits": {
    "title": "الزيارات الوقائية",
    "columns": {
      "period": "الفترة",
      "plan": "الخطة",
      "site": "الموقع",
      "due": "الاستحقاق",
      "status": "الحالة",
      "job": "الأمر",
      "next": "الزيارة التالية"
    },
    "status": {
      "PLANNED": "مخططة",
      "SCHEDULED": "مجدولة",
      "IN_PROGRESS": "قيد التنفيذ",
      "DONE": "تمت",
      "LATE": "متأخرة",
      "MISSED": "فائتة",
      "SKIPPED": "تم تخطيها"
    },
    "checked": "فُحصت {{checked}} من {{total}}",
    "doneOn": "تمت في {{date}}",
    "notScheduled": "غير مجدولة",
    "overdue": "متأخرة",
    "filterPlan": "الخطة",
    "filterSite": "الموقع",
    "filterStatus": "الحالة",
    "anyPlan": "أي خطة",
    "anySite": "أي موقع",
    "anyStatus": "أي حالة",
    "skip": "تخطي الزيارة",
    "skipStarted": "بدأت هذه الزيارة: حضرها فني، فلا يمكن تخطيها.",
    "actionsFor": "إجراءات {{period}} في {{site}}",
    "noMatches": "لا زيارات وقائية مطابقة.",
    "clearFilters": "مسح عوامل التصفية",
    "empty": "لا زيارات وقائية بعد.",
    "emptyNoPlans": "أضف خطة صيانة في تبويب خطط الصيانة: تُنشأ زياراتها قبل كل موعد.",
    "emptyDraft": "تُنشأ الزيارات الوقائية بعد تفعيل العقد.",
    "emptyBody": "يُنشئ المُخطِّط كل زيارة قبيل موعدها.",
    "skipDialog": {
      "title": "تخطي {{period}} في {{site}}",
      "body": "يُلغى أمرها الوقائي {{job}}، وتُستبعد الفترة من نسبة الالتزام.",
      "reason": "السبب",
      "reasonPlaceholder": "المستأجر مسافر طوال الصيف",
      "reasonRequired": "اذكر السبب.",
      "confirm": "تخطي الزيارة",
      "keep": "إبقاء الزيارة"
    },
    "toast": {
      "skipped": "تم تخطي زيارة {{period}} في {{site}}"
    }
  },
  "generate": {
    "running": "جارٍ إنشاء الزيارات الوقائية…",
    "made_zero": "لم تُنشأ أي زيارة وقائية",
    "made_one": "أُنشئت زيارة وقائية واحدة",
    "made_two": "أُنشئت زيارتان وقائيتان",
    "made_few": "أُنشئت {{n}} زيارات وقائية",
    "made_many": "أُنشئت {{n}} زيارة وقائية",
    "made_other": "أُنشئت {{n}} زيارة وقائية",
    "window": "كلٌّ منها مستحقة خلال الأيام الـ{{days}} القادمة.",
    "none": "لا زيارات وقائية جديدة: كل الفترات أُنشئت من قبل",
    "nothingDue": "لا زيارات وقائية مستحقة بعد: تُنشأ كل زيارة قبيل موعدها",
    "nextMake": "تُنشأ الزيارات التالية في {{date}}.",
    "noneMade": "لم تُنشأ أي زيارة وقائية",
    "failed_zero": "تعذّر على الخطط إنشاء زياراتها: {{plans}}",
    "failed_one": "تعذّر على خطة واحدة إنشاء زياراتها: {{plans}}",
    "failed_two": "تعذّر على خطتين إنشاء زياراتهما: {{plans}}",
    "failed_few": "تعذّر على {{n}} خطط إنشاء زياراتها: {{plans}}",
    "failed_many": "تعذّر على {{n}} خطة إنشاء زياراتها: {{plans}}",
    "failed_other": "تعذّر على {{n}} خطة إنشاء زياراتها: {{plans}}"
  },
  "activate": {
    "title": "تفعيل {{number}}؟",
    "covers_zero": "يشمل الأوامر من {{start}} إلى {{end}}.",
    "covers_one": "يشمل الأوامر في موقعه الواحد من {{start}} إلى {{end}}.",
    "covers_two": "يشمل الأوامر في موقعيه من {{start}} إلى {{end}}.",
    "covers_few": "يشمل الأوامر في مواقعه الـ{{n}} من {{start}} إلى {{end}}.",
    "covers_many": "يشمل الأوامر في مواقعه الـ{{n}} من {{start}} إلى {{end}}.",
    "covers_other": "يشمل الأوامر في مواقعه الـ{{n}} من {{start}} إلى {{end}}.",
    "plans_zero": "تبدأ خططه بإنشاء الأوامر الوقائية قبل {{days}} يوماً من كل موعد.",
    "plans_one": "تبدأ خطته بإنشاء الأوامر الوقائية قبل {{days}} يوماً من كل موعد.",
    "plans_two": "تبدأ خطتاه بإنشاء الأوامر الوقائية قبل {{days}} يوماً من كل موعد.",
    "plans_few": "تبدأ خططه الـ{{n}} بإنشاء الأوامر الوقائية قبل {{days}} يوماً من كل موعد.",
    "plans_many": "تبدأ خططه الـ{{n}} بإنشاء الأوامر الوقائية قبل {{days}} يوماً من كل موعد.",
    "plans_other": "تبدأ خططه الـ{{n}} بإنشاء الأوامر الوقائية قبل {{days}} يوماً من كل موعد.",
    "noPlans": "لا خطط صيانة له بعد: أضفها في تبويب خطط الصيانة لتكون له زيارات وقائية.",
    "instalments_zero": "لا أقساط من جدول الفوترة ({{schedule}}).",
    "instalments_one": "يُنشأ قسط واحد من جدول الفوترة ({{schedule}}).",
    "instalments_two": "يُنشأ قسطان من جدول الفوترة ({{schedule}}).",
    "instalments_few": "تُنشأ {{n}} أقساط من جدول الفوترة ({{schedule}}).",
    "instalments_many": "يُنشأ {{n}} قسطاً من جدول الفوترة ({{schedule}}).",
    "instalments_other": "يُنشأ {{n}} قسط من جدول الفوترة ({{schedule}}).",
    "customBilling": "جدول الفوترة مخصص: أدخل الأقساط في العقد.",
    "frozen": "لا يتغير بعد ذلك العميل ولا تاريخ البداية.",
    "confirm": "تفعيل العقد",
    "confirmApproval": "إرسال للاعتماد",
    "keep": "إبقاؤه مسودة"
  },
  "renew": {
    "title": "تجديد {{number}}",
    "body": "تبدأ مسودة جديدة في اليوم التالي لنهاية هذا العقد، بالمواقع والتغطية والشروط والخطط والفوترة نفسها.",
    "start": "يبدأ في",
    "end": "ينتهي في",
    "percent": "تغيير السعر",
    "percentHint": "5 ترفع السعر 5%؛ و -2.5 تخفضه.",
    "valuePreview": "القيمة {{from}} تصبح {{to}}",
    "valueUnknown": "أدخل التغيير نسبةً مئوية، مثل 5 أو -2.5.",
    "confirm": "إنشاء التجديد",
    "errors": {
      "end": "النهاية قبل البداية.",
      "percent": "أدخل نسبة مئوية، مثل 5 أو -2.5 (أكبر من -100)."
    }
  },
  "terminate": {
    "title": "إنهاء {{number}}",
    "body": "يتوقف العقد عن شمول الأوامر اعتباراً من التاريخ الذي تختاره. لا يمكن التراجع عن ذلك.",
    "date": "تاريخ السريان",
    "dateHint": "ضمن مدة العقد",
    "previewTitle": "ما يلغيه الإنهاء في {{date}}",
    "previewFailed": "تعذّر عرض ما سيُلغى.",
    "nothing": "لا شيء مخطط أو مُفوتر بعد هذا التاريخ: لن يُلغى شيء.",
    "jobs_zero": "لن يُلغى أي أمر وقائي:",
    "jobs_one": "سيُلغى أمر وقائي واحد ليست له زيارة بعد:",
    "jobs_two": "سيُلغى أمران وقائيان ليست لهما زيارة بعد:",
    "jobs_few": "ستُلغى {{n}} أوامر وقائية ليست لها زيارة بعد:",
    "jobs_many": "سيُلغى {{n}} أمراً وقائياً ليست لها زيارة بعد:",
    "jobs_other": "سيُلغى {{n}} أمر وقائي ليست لها زيارة بعد:",
    "instalments_zero": "لن يُلغى أي قسط:",
    "instalments_one": "سيُلغى قسط واحد غير مُفوتر:",
    "instalments_two": "سيُلغى قسطان غير مُفوترين:",
    "instalments_few": "ستُلغى {{n}} أقساط غير مُفوترة:",
    "instalments_many": "سيُلغى {{n}} قسطاً غير مُفوتر:",
    "instalments_other": "سيُلغى {{n}} قسط غير مُفوتر:",
    "due": "موعده {{date}}",
    "reason": "السبب",
    "confirm": "إنهاء العقد",
    "keep": "إبقاء العقد",
    "errors": {
      "date": "اختر تاريخاً ضمن مدة العقد.",
      "reason": "اذكر السبب."
    }
  },
  "cancel": {
    "title": "إلغاء المسودة {{number}}؟",
    "body": "تُحفظ مسودة {{customer}} ملغاة ويبقى رقمها مستخدماً.",
    "withdraws": "العقد بانتظار الاعتماد: إلغاؤه يسحب طلب الاعتماد وتُغلق مهام المعتمِدين.",
    "reason": "السبب",
    "confirm": "إلغاء المسودة",
    "keep": "إبقاء المسودة",
    "errors": {
      "reason": "اذكر السبب."
    }
  },
  "toast": {
    "created": "حُفظ العقد {{number}} مسودة",
    "createdActive": "العقد {{number}} ساري",
    "saved": "حُفظ العقد {{number}}",
    "activated": "العقد {{number}} ساري",
    "activatedFrom": "العقد {{number}} ساري اعتباراً من {{date}}",
    "sentForApproval": "أُرسل العقد {{number}} للاعتماد",
    "savedNotActivated": "حُفظ {{number}} مسودة ولم يُفعَّل: {{reason}}",
    "renewed": "أُنشئت مسودة التجديد {{number}}",
    "terminated": "أُنهي العقد {{number}}",
    "cancelled": "أُلغيت المسودة {{number}}"
  },
  "form": {
    "newTitle": "عقد صيانة جديد",
    "newMeta": "يُحفظ مسودة: يشمل الأوامر بعد تفعيله.",
    "editTitle": "تعديل {{number}}",
    "editMeta": {
      "DRAFT": "مسودة: كل شيء قابل للتغيير.",
      "ACTIVE": "ساري: يبقى العميل وتاريخ البداية؛ وتتأخر النهاية فقط؛ ويُحفظ كل تغيير في سجله."
    },
    "notEditable": "هذا العقد {{status}} ولم يعد يتغير.",
    "waitingTitle": "بانتظار الاعتماد",
    "waitingBody": "أُرسلت هذه المسودة للاعتماد، فلا تتغير حتى يُبت في الطلب. لتغييرها الآن اسحب الطلب من صفحة العقد.",
    "backToContract": "العودة إلى {{number}}",
    "stale": {
      "title": "تغيّر هذا العقد منذ أن فتحته",
      "kept": "ما كتبته هنا باقٍ ولم يُحفظ. حمّل أحدث نسخة لترى التغييرات، ثم أعد تغييراتك.",
      "notSaved": "لم تُحفظ تغييراتك، وما زالت هنا. حمّل أحدث نسخة لترى ما تغيّر، ثم أعد تغييراتك.",
      "clean": "حمّل أحدث نسخة لتعدّله كما هو الآن.",
      "locked": "لم يعد تعديله ممكنًا من هنا.",
      "load": "تحميل أحدث نسخة",
      "loadDiscard": "تحميل أحدث نسخة (تُفقد تغييراتك)",
      "loadFailed": "تعذّر تحميل أحدث نسخة. حاول مجددًا."
    },
    "sections": {
      "customer": "العميل والمواقع",
      "coverage": "التغطية",
      "terms": "الشروط",
      "plans": "خطط الصيانة",
      "price": "السعر والفوترة",
      "review": "ما يحصل عليه العميل"
    },
    "customer": "العميل",
    "customerFirst": "اختر العميل أولاً: تُعرض مواقعه هنا.",
    "customerChange": {
      "title": "تغيير العميل؟",
      "body_zero": "تُمسح المواقع المختارة: إنها للعميل الحالي.",
      "body_one": "يُمسح الموقع المختار: إنه للعميل الحالي.",
      "body_two": "يُمسح الموقعان المختاران: إنهما للعميل الحالي.",
      "body_few": "تُمسح المواقع الـ{{n}} المختارة: إنها للعميل الحالي.",
      "body_many": "تُمسح المواقع الـ{{n}} المختارة: إنها للعميل الحالي.",
      "body_other": "تُمسح المواقع الـ{{n}} المختارة: إنها للعميل الحالي.",
      "bodyAssets_zero": "تُمسح {{assets}}: إنها للعميل الحالي.",
      "bodyAssets_one": "يُمسح الموقع المختار و{{assets}}: إنها للعميل الحالي.",
      "bodyAssets_two": "يُمسح الموقعان المختاران و{{assets}}: إنها للعميل الحالي.",
      "bodyAssets_few": "تُمسح المواقع الـ{{n}} المختارة و{{assets}}: إنها للعميل الحالي.",
      "bodyAssets_many": "تُمسح المواقع الـ{{n}} المختارة و{{assets}}: إنها للعميل الحالي.",
      "bodyAssets_other": "تُمسح المواقع الـ{{n}} المختارة و{{assets}}: إنها للعميل الحالي.",
      "assets_zero": "المعدات المختارة",
      "assets_one": "المعدة المختارة",
      "assets_two": "المعدتان المختارتان",
      "assets_few": "المعدات الـ{{n}} المختارة",
      "assets_many": "المعدات الـ{{n}} المختارة",
      "assets_other": "المعدات الـ{{n}} المختارة",
      "confirm": "تغيير العميل",
      "keep": "إبقاء العميل"
    },
    "title": "العنوان",
    "titleHint": "اختياري؛ يُطبع على العقد",
    "titlePlaceholder": "برج النور: صيانة المكيفات",
    "start": "يبدأ في",
    "end": "ينتهي في",
    "startFixed": "يحتفظ العقد الساري بتاريخ بدايته.",
    "endLaterOnly": "نهاية العقد الساري تتأخر فقط.",
    "sites": "المواقع",
    "sitesAll": "اختيار الكل",
    "sitesNone": "مسح الكل",
    "siteAssets_zero": "لا معدات",
    "siteAssets_one": "معدة واحدة",
    "siteAssets_two": "معدتان",
    "siteAssets_few": "{{n}} معدات",
    "siteAssets_many": "{{n}} معدة",
    "siteAssets_other": "{{n}} معدة",
    "siteUnder": "ضمن {{number}} حتى {{date}}",
    "sitesFailed": "تعذّر تحميل مواقع العميل.",
    "noSites": "ليس لهذا العميل مواقع خدمة بعد.",
    "noSitesAdd": "أضف أول موقع من هنا، ويُختار لهذا العقد مباشرة.",
    "noSitesAsk": "يمكن لمن يدير مواقع الخدمة إضافة موقع من تبويب الخدمة في ملف العميل.",
    "addSite": "إضافة موقع",
    "consumables": {
      "title": "فئات المواد الاستهلاكية",
      "body": "تُعدّ أصناف هذه الفئات من الكتالوج مواد استهلاكية في كل عقود الصيانة (الإعدادات › العقود).",
      "label": "الفئات",
      "save": "حفظ الفئات",
      "keep": "الإبقاء كما هي",
      "saved": "حُفظت فئات المواد الاستهلاكية ({{n}})"
    },
    "coverage": {
      "mode": "ما يشمله العقد",
      "ALL": "كل شيء",
      "ALLBody": "كل معدة في المواقع المختارة، الآن وكلما أُضيفت معدات.",
      "TYPES": "أنواع معدات",
      "TYPESBody": "معدات الأنواع المختارة في المواقع (كل المكيفات مثلاً).",
      "ASSETS": "اختيار معدات",
      "ASSETSBody": "قائمة معدات مختارة؛ والمعدة المستبدلة تنقل مكانها إلى الجديدة.",
      "types": "أنواع المعدات",
      "typesPlaceholder": "اختر أنواع المعدات التي يشملها",
      "pickSitesFirst": "اختر المواقع أولاً: تُعرض معداتها هنا.",
      "pickedHere": "اختيرت {{picked}} من {{total}}",
      "place": "المكان",
      "searchAssets": "ابحث بالرمز أو الموضع أو المكان…",
      "searchAssetsAt": "ابحث في معدات {{site}}",
      "clearSearch": "مسح البحث",
      "selectAllHere": "اختيار الـ{{n}} كلها هنا",
      "clearHere": "مسح هذا الموقع",
      "selectFailed": "تعذّر اختيارها كلها. حاول مرة أخرى.",
      "assetsFailed": "تعذّر تحميل المعدات.",
      "assetsAt": "معدات {{site}}",
      "noMatch": "لا معدة مطابقة.",
      "noAssetsHere": "لا معدات هنا.",
      "cutOff": "يُعرض {{n}} من {{total}}: اكتب أكثر للتضييق أو اخترها كلها.",
      "goneTitle_zero": "لا معدات مختارة خارج الخدمة",
      "goneTitle_one": "معدة مختارة واحدة لم تعد في الخدمة",
      "goneTitle_two": "معدتان مختارتان لم تعودا في الخدمة",
      "goneTitle_few": "{{n}} معدات مختارة لم تعد في الخدمة",
      "goneTitle_many": "{{n}} معدة مختارة لم تعد في الخدمة",
      "goneTitle_other": "{{n}} معدة مختارة لم تعد في الخدمة",
      "replacedBy": "استُبدلت بـ{{tag}}",
      "removed": "أُزيلت",
      "pickSuccessor": "اختيار {{tag}}",
      "successorPicked": "اختيرت بديلتها"
    },
    "terms": {
      "labour": {
        "INCLUDED": "مشمولة",
        "INCLUDEDBody": "لا رسوم عمالة على المعدات المشمولة.",
        "EXCLUDED": "بمقابل",
        "EXCLUDEDBody": "تُحتسب العمالة في كل أمر."
      },
      "parts": {
        "INCLUDED": "مشمولة",
        "INCLUDEDBody": "قطع غيار المعدات المشمولة بلا مقابل.",
        "EXCLUDED": "بمقابل",
        "EXCLUDEDBody": "تُحتسب قطع الغيار في كل أمر.",
        "CAPPED": "حتى سقف",
        "CAPPEDBody": "مشمولة حتى مبلغ معين؛ وما زاد عليه بمقابل."
      },
      "consumables": {
        "INCLUDED": "مشمولة",
        "INCLUDEDBody": "الفلاتر والغاز ومواد التنظيف (الفئات المحددة في الإعدادات › العقود).",
        "EXCLUDED": "بمقابل",
        "EXCLUDEDBody": "تُحتسب المواد الاستهلاكية في كل أمر."
      },
      "callOuts": {
        "INCLUDED": "مشمولة",
        "INCLUDEDBody": "زيارات الأعطال مشمولة، حتى عدد سنوي إن حددته.",
        "EXCLUDED": "بمقابل",
        "EXCLUDEDBody": "يُحتسب كل بلاغ عطل؛ وتبقى الزيارات الوقائية مشمولة."
      },
      "cap": "سقف قطع الغيار (قبل الضريبة)",
      "capBasis": "السقف",
      "basis": {
        "PER_JOB": "لكل أمر",
        "PER_YEAR": "لكل سنة عقد"
      },
      "perYear": "بلاغات الأعطال سنوياً",
      "perYearHint": "اتركه فارغاً لعدد غير محدود",
      "unlimited": "غير محدود",
      "response": "زمن الاستجابة (ساعات)",
      "responseHint": "يظهر في كل أمر؛ اختياري",
      "specialHint": "ما لا تذكره الشروط العامة؛ يُطبع على العقد.",
      "noConsumables": "لم تُحدَّد فئات المواد الاستهلاكية في الإعدادات › العقود، فلا يُعدّ أي صنف مادة استهلاكية بعد.",
      "noConsumablesLink": "اختيار الفئات",
      "noConsumablesAsk": "يستطيع المسؤول اختيارها من الإعدادات › العقود."
    },
    "plansBody": "تُنشئ خطط الصيانة الزيارات الوقائية. أضفها الآن أو لاحقاً في تبويب خطط الصيانة في العقد.",
    "noPlans": "لا خطط صيانة بعد.",
    "addPlan": "إضافة خطة صيانة",
    "removePlan": "حذف الخطة",
    "removePlanNamed": "حذف الخطة {{name}}",
    "planRow": "الخطة {{n}}",
    "planRemoved": "حُذفت الخطة {{name}}",
    "undo": "تراجع",
    "value": "القيمة (قبل الضريبة)",
    "valueHint": "عن المدة كاملة",
    "taxRate": "ضريبة القيمة المضافة",
    "taxDefault": "النسبة الافتراضية للشركة",
    "taxDefaultNamed": "الافتراضية: {{name}}",
    "schedule": "جدول الفوترة",
    "timing": "موعد فوترة كل قسط",
    "instalments": {
      "title_zero": "لا أقساط",
      "title_one": "قسط واحد",
      "title_two": "قسطان",
      "title_few": "{{n}} أقساط",
      "title_many": "{{n}} قسطاً",
      "title_other": "{{n}} قسط",
      "caption": "الأقساط التي يُنشئها الجدول",
      "period": "الفترة",
      "billed": "يُفوتر في",
      "amount": "المبلغ",
      "total": "المجموع (القيمة)",
      "custom": "جدول مخصص: تُدخل الأقساط في العقد بعد تفعيله.",
      "none": "أدخل القيمة والمدة لعرض الأقساط.",
      "free": "لا أقساط: العقد بلا مقابل.",
      "failed": "تعذّر تحميل أقساط العقد.",
      "existing_zero": "لا أقساط في العقد",
      "existing_one": "قسط واحد في العقد",
      "existing_two": "قسطان في العقد",
      "existing_few": "{{n}} أقساط في العقد",
      "existing_many": "{{n}} قسطاً في العقد",
      "existing_other": "{{n}} قسط في العقد",
      "existingCaption": "أقساط العقد",
      "valueOnly": "الحفظ يغيّر القيمة فقط. أعد بناء الأقساط غير المفوترة من تبويب الفوترة.",
      "matches": "الأقساط غير المفوترة تطابق هذه القيمة والجدول.",
      "customOnly": "الجدول مخصص: عدّل الأقساط يدوياً من تبويب الفوترة.",
      "rebuildNone": "لن تترك إعادة البناء أي قسط للفوترة: الأقساط المفوترة تغطي القيمة.",
      "rebuildWould_zero": "لن تُنشئ إعادة البناء أي قسط:",
      "rebuildWould_one": "ستُنشئ إعادة البناء قسطاً واحداً:",
      "rebuildWould_two": "ستُنشئ إعادة البناء قسطين:",
      "rebuildWould_few": "ستُنشئ إعادة البناء {{n}} أقساط:",
      "rebuildWould_many": "ستُنشئ إعادة البناء {{n}} قسطاً:",
      "rebuildWould_other": "ستُنشئ إعادة البناء {{n}} قسط:"
    },
    "saveDraft": "حفظ مسودة",
    "save": "حفظ العقد",
    "saveAndActivate": "حفظ وتفعيل",
    "moreActions": "إجراءات أخرى",
    "errors": {
      "notSaved": "لم يُحفظ العقد",
      "fix": "بعض الحقول تحتاج إلى مراجعة.",
      "customer": "اختر العميل.",
      "date": "أدخل تاريخاً.",
      "endBeforeStart": "النهاية قبل البداية.",
      "sites": "اختر كل موقع مرة واحدة.",
      "sitesToActivate": "اختر موقعاً واحداً على الأقل لتفعيل العقد.",
      "types": "اختر أنواع المعدات التي يشملها.",
      "assets": "اختر المعدات التي يشملها.",
      "partsCap": "أدخل سقف قطع الغيار.",
      "partsCapBasis": "لكل أمر أم لكل سنة عقد؟",
      "callOutsPerYear": "أدخل رقماً من 1 إلى 365، أو اتركه فارغاً لعدد غير محدود.",
      "responseHours": "أدخل ساعات من 1 إلى 720، أو اتركها فارغة.",
      "value": "أدخل القيمة: صفر أو أكثر."
    },
    "salesperson": "مندوب المبيعات",
    "salespersonHint": "من باع العقد: تُنسب إليه فواتير أقساطه.",
    "salespersonDefault": "مندوب مبيعات العميل"
  },
  "summary": {
    "title": "ما يحصل عليه العميل",
    "who": "لصالح",
    "when": "المدة",
    "what": "المشمول",
    "terms": "بهذه الشروط",
    "plans": "الزيارات الوقائية",
    "price": "السعر",
    "noCustomer": "اختر العميل.",
    "noSites": "لا مواقع بعد",
    "typesNone": "اختر أنواع المعدات",
    "covered_zero": "لا معدات مشمولة",
    "covered_one": "معدة واحدة مشمولة",
    "covered_two": "معدتان مشمولتان",
    "covered_few": "{{n}} معدات مشمولة",
    "covered_many": "{{n}} معدة مشمولة",
    "covered_other": "{{n}} معدة مشمولة",
    "coveredUnknown": "جارٍ عدّ المعدات المشمولة…",
    "noPlans": "لا خطط صيانة بعد.",
    "noValue": "أدخل القيمة.",
    "priceOnly": "{{value}} قبل الضريبة",
    "priceUpfront": "{{value}} قبل الضريبة، بقسط واحد، {{timing}}",
    "priceBilled_zero": "{{value}} قبل الضريبة، بلا أقساط",
    "priceBilled_one": "{{value}} قبل الضريبة، بقسط واحد، {{schedule}} {{timing}}",
    "priceBilled_two": "{{value}} قبل الضريبة، بقسطين، {{schedule}} {{timing}}",
    "priceBilled_few": "{{value}} قبل الضريبة، على {{n}} أقساط، {{schedule}} {{timing}}",
    "priceBilled_many": "{{value}} قبل الضريبة، على {{n}} قسطاً، {{schedule}} {{timing}}",
    "priceBilled_other": "{{value}} قبل الضريبة، على {{n}} قسط، {{schedule}} {{timing}}",
    "valueShort": "{{value}}"
  },
  "customerTab": {
    "title": "العقود",
    "count_zero": "لا عقود صيانة",
    "count_one": "عقد صيانة واحد",
    "count_two": "عقدا صيانة",
    "count_few": "{{n}} عقود صيانة",
    "count_many": "{{n}} عقد صيانة",
    "count_other": "{{n}} عقد صيانة",
    "showAll": "عرض في سجل العقود",
    "empty": "لا عقود صيانة.",
    "emptyBody": "أضف عقداً يشمل مواقع هذا العميل."
  },
  "job": {
    "coverageTitle": "عقد الصيانة",
    "coveredBy": "عقد صيانة يشمل هذا الموقع",
    "coveredByMany": "عقود صيانة تشمل هذا الموقع",
    "billUnder": "كيف يُحتسب الأمر",
    "underContract": "ضمن العقد {{number}}",
    "chargeable": "بمقابل",
    "chargeableBody": "يُحتسب هذا الأمر كالمعتاد خارج العقد.",
    "coveredByNumber": "مشمول بالعقد {{number}}",
    "billedAsUsual": "يُحتسب كالمعتاد · العقد {{number}} يشمل هذا الموقع",
    "billInstead": "احتسابه بمقابل",
    "useContract": "استخدام العقد",
    "overAllowanceNext": "هذا البلاغ يتجاوز العدد المشمول للسنة: ستكون عمالته بمقابل.",
    "notCoveredAssets": "غير مشمول: {{assets}}",
    "notCoveredOthers_zero": "لا معدّات أخرى",
    "notCoveredOthers_one": "معدّة أخرى",
    "notCoveredOthers_two": "معدّتان أخريان",
    "notCoveredOthers_few": "{{n}} معدّات أخرى",
    "notCoveredOthers_many": "{{n}} معدّة أخرى",
    "notCoveredOthers_other": "{{n}} معدّة أخرى",
    "blockTitle": "عقد الصيانة الخاص بالأمر",
    "under": "ضمن العقد",
    "planned": "زيارة وقائية · {{plan}} · {{period}}",
    "overAllowance": "تجاوز عدد بلاغات الأعطال المشمولة للسنة: العمالة في هذا الأمر بمقابل.",
    "notCovered_zero": "غير مشمولة بالعقد:",
    "notCovered_one": "غير مشمولة بالعقد:",
    "notCovered_two": "غير مشمولتين بالعقد:",
    "notCovered_few": "غير مشمولة بالعقد:",
    "notCovered_many": "غير مشمولة بالعقد:",
    "notCovered_other": "غير مشمولة بالعقد:",
    "itemCovered": "مشمول",
    "itemChargeable": "بمقابل"
  },
  "site": {
    "chip": "ضمن عقد",
    "chipTitle": "{{number}}، حتى {{date}}"
  },
  "asset": {
    "title": "تغطية العقد",
    "none": "غير مشمولة بعقد صيانة.",
    "nextDue": "التالي {{date}}"
  },
  "print": {
    "title": "عقد صيانة",
    "back": "العودة إلى {{number}}",
    "draftNote": "مسودة: تُطبع بعلامة «مسودة» حتى تُفعَّل.",
    "billingFailed": "تعذّر تحميل أقساط العقد، فلا يُطبع بعد.",
    "period": "المدة",
    "activated": "تاريخ التفعيل",
    "renews": "تجديد للعقد",
    "customer": "العميل",
    "subject": "الموضوع",
    "sites": "المواقع",
    "coverage": "التغطية",
    "terms": "الشروط",
    "plans": "الصيانة الوقائية",
    "plan": "الخطة",
    "how": "التكرار",
    "checklist": "قائمة الفحص",
    "price": "السعر والفوترة",
    "instalments": "الأقساط",
    "plusTax": "تُضاف ضريبة القيمة المضافة بنسبة {{rate}}%",
    "plusDefaultTax": "تُضاف ضريبة القيمة المضافة",
    "signatures": "التوقيعات",
    "forCompany": "عن الشركة",
    "forCustomer": "عن العميل",
    "signName": "الاسم",
    "signSignature": "التوقيع",
    "signDate": "التاريخ",
    "footer": "تُصان المعدات المشمولة وفق هذه الشروط.",
    "footerMoney": "المبالغ بالريال العماني (<rial/>) قبل الضريبة."
  },
  "tasks": {
    "renewalTitle": "متابعة تجديد {{number}}",
    "followUpTitle": "متابعة {{number}}"
  },
  "approval": {
    "needed": "تفعيل هذا العقد يرسله للاعتماد أولًا.",
    "neededWorkflow": "مسار الاعتماد: {{name}}",
    "waiting": "بانتظار الاعتماد",
    "waitingStep": "بانتظار «{{step}}» · الخطوة {{index}} من {{total}}",
    "locked": "لا يتغير العقد حتى يُبتّ في الطلب.",
    "onHoldBody": "الطلب مجمّد: لا يمكن لأحد اعتماده أو رفضه أو سحبه، ويبقى العقد مسودة حتى يُعاد تفعيل مسارات الاعتماد.",
    "activating": "اعتُمد؛ جارٍ تفعيل العقد…",
    "activateFailed": "اعتُمد، لكن العقد لم يُفعَّل.",
    "approved": "معتمد",
    "stale": "تغيّر العقد بعد اعتماده. فعّله مجددًا.",
    "rejected": "مرفوض",
    "returned": "أُعيد للتعديل",
    "editResend": "عدّل العقد عند الحاجة ثم فعّله مجددًا لإرساله للاعتماد.",
    "withdrawn": "سُحب طلب الاعتماد. فعّل العقد مجددًا عندما يكون جاهزًا.",
    "withdrawBody": "تُغلق مهام المعتمدين ويمكن تعديل العقد مجددًا. تفعيله يرسله للاعتماد من جديد."
  },
  "approvalDetail": {
    "covers": "يشمل:",
    "terms": "الشروط:",
    "priceChange": "السعر:",
    "priceChangeBody": "{{change}} عن {{number}}: {{from}} ← {{to}}"
  }
}
